import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';

import { Workpaper, TrialBalanceAccountingBasisEnum, WorkpaperRoleEnum, WorkpaperPermissions } from '../types/workpaper';

export type CreateWorkpaperRequest = {
    name: string;
    entityId: string;
    periodEnd: string;
    dueDate: string;
    procedureTemplateId: string;
    checklistId: string;
    materialityLimit?: { amount: number; isPercentage: boolean };
    assigned: { role: WorkpaperRoleEnum; userId: string }[];
    private: boolean;
    permissions: WorkpaperPermissions;
    accountingBasis: TrialBalanceAccountingBasisEnum;
    provider?: string | null;
    trialBalance?: { code: string; debitTY: number | null; creditTY: number | null; debitLY: number | null; creditLY: number | null }[];
    integrations?: {
        fyiJob?: string;
    };
    priorWorkpaperId?: string;
    templates?: { calculationIds: string[] };
};

async function createWorkpaper(req: CreateWorkpaperRequest): Promise<PostResponseBody<Workpaper>> {
    const { data } = await api.post('/workpapers', req);
    return data;
}

export function useCreateWorkpaper(): UseMutationResult<PostResponseBody<Workpaper>, AxiosError, CreateWorkpaperRequest, unknown> {
    return useMutation(createWorkpaper, {
        onSettled: () => {
            queryClient.invalidateQueries(['workpapers']);
            queryClient.invalidateQueries(['firm']);
        },
    });
}
